import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import { ProviderServiceOptionRepository } from "./impl/service/repository/providerServiceOption.repository";
import { ProviderServiceOptionDataService } from "./impl/service/repository/providerServiceOption.dataservice";

@NgModule({
})
export class ProviderServiceOptionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: ProviderServiceOptionRepository,
                dataService: ProviderServiceOptionDataService) {

        entityDataService.registerServices({
            ProviderServiceOption: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ProviderServiceOption: repository,
        });
    }
}

